import { SubmitButton } from "@/components/Global/Button/Button";
import { FormErrorState, Input } from "@/components/Global/Input/Input";
import { useAppContext } from "@/context/AppContext";
import { customSanitize } from "@/utils/customSanitize";
import { confirmDeleteUser } from "@/utils/serviceAPI/user";
import { safeParseSchema, DeleteCodeSchema } from "@/utils/validations";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React, { FormEvent, useState } from "react";

function ConfirmDeleteModal() {
  const { getLabel } = useGlobalContext();
  const { setFormModalType, setFormModalText, user } = useAppContext();
  const [errors, setErrors] = useState<FormErrorState>();
  const validationMessages = {
    required_field: getLabel("required_field"),
  };
  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const formProps = Object.fromEntries(formData);
    const { data, flattenedErrors } = safeParseSchema(
      DeleteCodeSchema(validationMessages),
      formProps,
    );
    if (data && user) {
      setErrors({});
      const code = (data as { code: string }).code;
      const res = await confirmDeleteUser(code, user);
      if (res instanceof Error || !res) {
        setErrors({
          code: [getLabel("code_invalid")],
        });
      } else {
        setFormModalText("Account gelöscht. Sie werden ausgeloggt.");
        setFormModalType("text");
        sessionStorage.removeItem("loggedIn");
        sessionStorage.removeItem("userData");
      }
    } else {
      setErrors(flattenedErrors);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <p
        dangerouslySetInnerHTML={{
          __html: customSanitize(getLabel("delete_account_modal_text")),
        }}
      ></p>
      <Input
        inputType="text"
        name="code"
        label={getLabel("confirmation_code")}
        placeholder={"ABCDE"}
        errors={errors}
      ></Input>
      <SubmitButton>{getLabel("delete_account_button")}</SubmitButton>
    </form>
  );
}

export default ConfirmDeleteModal;
